import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import RequestDetail from "../components/RequestDetail";
import { useZone } from "../../../shared/context/ZoneContext";
import { getDashboardDataByZone } from "../data/dashboardMockData";

export default function RequestDetailPage() {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const { selectedZone } = useZone();
  const { requests: zoneRequests } = getDashboardDataByZone(selectedZone);
  const [requests, setRequests] = useState(zoneRequests);

  const request = requests.find((r) => r.id === requestId);

  const handleApprove = (id, comment) => {
    console.log("Approved:", id, comment);
    setRequests((prev) => prev.filter((item) => item.id !== id));
    navigate("/requests");
  };

  const handleReject = (id, comment) => {
    console.log("Rejected:", id, comment);
    setRequests((prev) => prev.filter((item) => item.id !== id));
    navigate("/requests");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 2.5, md: 3, lg: 4 },
        }}
      >
        {request ? (
          <RequestDetail
            request={request}
            onApprove={handleApprove}
            onReject={handleReject}
          />
        ) : (
          <Typography sx={{ color: "#62748E", fontSize: "16px" }}>
            Request not found.
          </Typography>
        )}
      </Box>
    </Box>
  );
}
